export default __webpack_public_path__ + "static/media/node.127880a1.png";